module.exports = __webpack_public_path__ + "static/media/right_tree@3x.ead2007d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/subject/right_tree@3x.png
// module id = 785
// module chunks = 1